import script from "./BaseTooltipCardClose.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseTooltipCardClose.vue?vue&type=script&setup=true&lang=js"

import "./BaseTooltipCardClose.vue?vue&type=style&index=0&id=39a1f808&lang=scss"

const __exports__ = script;

export default __exports__